import React, { useState } from "react";
import bars from "../../../assets/images/icons/bars.svg";
import close from "../../../assets/images/icons/close.svg";
//import logo from "../../../assets/images/logo/logo.png";

const NavBar = () => {
  const [showParent, setShowParent] = useState(false);
  return (
    <section className="navbar">
      <div className="container">
        <div className="large">
          <div className="nav-contents flex">
            <a className="brand-side boldTitle" href="/">
              {/*<img src={logo} alt="Nexus Events Uganda logo" />*/}
              NEXUS EVENTS
            </a>
            <nav className="menu-side relative">
              <label
                onClick={() => setShowParent(true)}
                htmlFor="toggle-responsive-menu"
                className="nav-label bold-title"
              >
                <img src={bars} alt="Menu" />
              </label>
              <input type="checkbox" id="toggle-responsive-menu" />
              <div
                onClose={() => setShowParent(false)}
                showParent={showParent}
                className={`menu-side-inner ${showParent ? "showParent" : ""}`}
              >
                <div className="hide-menu">
                  <button
                    onClick={() => setShowParent(false)}
                    className="hide-menu-btn button"
                  >
                    <img src={close} alt="Close Menu" />
                  </button>
                </div>
                <ul className="main-menu">
                  <li>
                    <a href="/about">About</a>
                  </li>
                  <li>
                    <a href="/services">Services</a>
                  </li>
                  <li>
                    <a href="/portfolio">Portfolio</a>
                  </li>
                  <li>
                    <a href="/contact">Contact Us</a>
                  </li>
                </ul>
                <a
                  href="https://form.jotform.com/nexusevents256/book-nexus-events-for-your-event"
                  className="button white nav-cta boldTitle uppercase"
                >
                  Book Now
                </a>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NavBar;
